import {
  Grid,
  TextField,
  IconButton,
  InputAdornment,
  Box,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useState } from "react";
import { Controller } from "react-hook-form";

export const CredentialsForm = ({
  isEditForm,
  control,
  errors,
  nrpsFields,
  handleAddNewNrp,
  handleRemoveNrp,
  t,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  /**
   * Función para mostrar u ocultar la contraseña
   */
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  /**
   * Evita que el campo de entrada pierda el foco cuando se hace clic en el botón
   * del ojo para mostrar u ocultar la contraseña
   * @param {*} event // Evento del mouse
   */
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Grid
      container
      alignItems="center"
      rowGap="2rem"
      padding={{ xs: 0, sm: "1rem" }}
    >
      <Grid
        item
        xs={12}
        container
        gap="2rem"
        alignItems="center"
        justifyContent="flex-start"
      >
        <Grid item xs={12} md>
          <Controller
            name="companyName"
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextField
                onChange={onChange}
                value={value}
                label={t(
                  "App.infonavitUploadCredentials.formModal.form.companyNameL"
                )}
                className={`${
                  errors.companyName
                    ? "modalEditRoles__form-input--error"
                    : "modalEditRoles__form-input modalEditRoles__form-input--stable"
                } full-width`}
                FormHelperTextProps={{
                  style: {
                    margin: "-5px 0 1px 0px",
                    color: "#e52900",
                    fontSize: 10,
                  },
                }}
                helperText={
                  errors.companyName ? errors.companyName.message : ""
                }
                InputLabelProps={{
                  style: {
                    margin: "-5px 0 0 -10px",
                    padding: "0 0 0 5px",
                    color: "#8c8d9d",
                    fontSize: 13,
                  },
                }}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md>
          <Controller
            name="rfc"
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextField
                onChange={onChange}
                disabled={isEditForm}
                value={value}
                label={t("App.infonavitUploadCredentials.formModal.form.rfcL")}
                className={`${
                  errors.rfc
                    ? "modalEditRoles__form-input--error"
                    : "modalEditRoles__form-input modalEditRoles__form-input--stable"
                } full-width`}
                FormHelperTextProps={{
                  style: {
                    margin: "-5px 0 1px 0px",
                    color: "#e52900",
                    fontSize: 10,
                  },
                }}
                helperText={errors.rfc ? errors.rfc.message : ""}
                InputLabelProps={{
                  style: {
                    margin: "-5px 0 0 -10px",
                    padding: "0 0 0 5px",
                    color: "#8c8d9d",
                    fontSize: 13,
                  },
                }}
              />
            )}
          />
        </Grid>

        <Grid
          item
          xs="auto"
          sx={{ display: { xs: "none", md: "initial" } }}
          style={{ opacity: 0 }}
        >
          <IconButton className="addPermission__button">
            <AddIcon sx={{ fontSize: 22 }} />
          </IconButton>
        </Grid>
      </Grid>

      {nrpsFields.map((nrp, index) => {
        return (
          <Grid
            item
            xs={12}
            container
            gap="2rem"
            alignItems="center"
            justifyContent="flex-start"
            key={index}
          >
            {index === 0 ? (
              <Grid item xs={12} sm>
                <Controller
                  name="rfcPKey"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      onChange={onChange}
                      value={value}
                      type={showPassword ? "text" : "password"}
                      label={t(
                        "App.infonavitUploadCredentials.formModal.form.passwordL"
                      )}
                      className={`${
                        errors.rfcPKey
                          ? "modalEditRoles__form-input--error"
                          : "modalEditRoles__form-input modalEditRoles__form-input--stable"
                      } full-width`}
                      FormHelperTextProps={{
                        style: {
                          margin: "-5px 0 1px 0px",
                          color: "#e52900",
                          fontSize: 10,
                        },
                      }}
                      helperText={errors.rfcPKey ? errors.rfcPKey.message : ""}
                      InputLabelProps={{
                        style: {
                          margin: "-5px 0 0 -10px",
                          padding: "0 0 0 5px",
                          color: "#8c8d9d",
                          fontSize: 13,
                        },
                      }}
                      inputProps={{
                        autocomplete: "new-password",
                      }}
                      InputProps={{
                        startAdornment: value ? (
                          <InputAdornment position="start">
                            <IconButton
                              style={{ marginBottom: "1.1rem" }}
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ) : null,
                      }}
                    />
                  )}
                />
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                sm
                sx={{ display: { xs: "none", sm: "initial" } }}
              ></Grid>
            )}

            <Grid item xs={index === 0 ? 12 : true} sm>
              <Controller
                name={`nrps.${index}`}
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    onChange={onChange}
                    value={value}
                    label={t(
                      "App.infonavitUploadCredentials.formModal.form.nrpL"
                    )}
                    className={`${
                      errors?.nrps?.[index]
                        ? "modalEditRoles__form-input--error"
                        : "modalEditRoles__form-input modalEditRoles__form-input--stable"
                    } full-width`}
                    FormHelperTextProps={{
                      style: {
                        margin: "-5px 0 1px 0px",
                        color: "#e52900",
                        fontSize: 10,
                      },
                    }}
                    helperText={
                      errors?.nrps?.[index] ? errors.nrps?.[index].message : ""
                    }
                    InputLabelProps={{
                      style: {
                        margin: "-5px 0 0 -10px",
                        padding: "0 0 0 5px",
                        color: "#8c8d9d",
                        fontSize: 13,
                      },
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item xs="auto">
              {index === 0 ? (
                <IconButton
                  className="addPermission__button"
                  onClick={handleAddNewNrp}
                >
                  <Box sx={{ display: { xs: "initial", sm: "none" } }}>
                    {t("App.infonavitUploadCredentials.formModal.addBtn")}
                  </Box>

                  <AddIcon sx={{ fontSize: 22 }} />
                </IconButton>
              ) : (
                <IconButton
                  className="addPermission__delete"
                  onClick={() => handleRemoveNrp(index)}
                >
                  <ClearIcon sx={{ fontSize: 22 }} />
                </IconButton>
              )}
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};
